module.exports = __webpack_public_path__ + "static/media/anteiaR.2a3eb0e7.svg";